module.exports = __webpack_public_path__ + "img/logo_2.f3872a7d.png";